import React from 'react';
import Title from "../../Title/Title";
import AboutHero from "./AboutHero";
import {Grid} from "@mui/material";
import './About.css';
import CustomHorizontalSpace from "../../Assistants/SpaceAssistant";
import OurTeam from "./OurTeam";
import charite from '../../../resources/images/charite_mitte.jpg'
import OurHistory from "./OurHistory";
import GoogleMapsConsent from "./GoogleMapsConsent";

function About() {
    return <>
        <Title title={'About Us'} img={charite}/>
        <CustomHorizontalSpace space={100}/>
        <AboutHero/>
        <CustomHorizontalSpace space={200}/>

        <Grid container direction={'column'}
              style={{justifyContent: "flex-start", alignItems: "flex-start", marginLeft: "10%"}}>
            <div className={"line"}/>
            <h1>Meet Our Experts</h1>
        </Grid>
        <Grid container direction={'column'} style={{justifyContent: "center", alignItems: "center"}}>
            <CustomHorizontalSpace space={100}/>
            <div style={{width: "80%"}}>
                <OurTeam/>
            </div>
        </Grid>
        <CustomHorizontalSpace space={200}/>

        <Grid container direction={'column'}
              style={{justifyContent: "flex-start", alignItems: "flex-start", marginLeft: "10%"}}>
            <div className={"line"}/>
            <h1>Our History</h1>
        </Grid>

        <CustomHorizontalSpace space={100}/>
        <Grid container className={'grid--item'}>
            <OurHistory/>
        </Grid>
        <CustomHorizontalSpace space={200}/>
        <div className={"line"} style={{marginLeft: "10%"}}/>
        <h1 style={{textAlign: 'left', marginLeft: '10%', marginRight: '10%'}}>
            Get started with us today!
        </h1>
        <CustomHorizontalSpace space={200}/>
        <Grid container className={'grid--item'} direction={'column'}>
            <GoogleMapsConsent/>
        </Grid>
        <CustomHorizontalSpace space={200}/>

    </>
}

export default About;